/**
 *  rl-role.model
 *  app-relayter-web
 *  Created by nandamhuis on 23/02/2017.
 *  Copyright © 2017 Creative Media Network. All rights reserved.
 */
import { autoserialize } from 'cerialize';
import { INucTableItem } from '../interfaces/table-item.interface';
import { INucDropdownItem } from '@relayter/rubber-duck';

export class RoleModel implements INucDropdownItem, INucTableItem {
    @autoserialize public _id: string;
    @autoserialize public name: string;
    @autoserialize public users: number = 0;

    @autoserialize public number: number;
    @autoserialize public root: boolean;
    @autoserialize public permissions: string[] = [];

    /**
     * INucDropdownItem implementation
     * @returns {string}
     */
    public getTitle(): string {
        return this.name;
    }

    /**
     * INucDropdownItem implementation
     * @returns {string}
     */
    public getValue(): string {
        return this._id;
    }
}
